import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { GetAllPainelContadorRequest } from '../../requests/repo-dfe/get-all-painel-contador.request';
import { RelatorioCfopResponse } from '../../responses/repo-dfe/relatorio-cfop.response';
import { CommonService } from '../../common-service';

@Injectable({
  providedIn: 'root'
})
export class RelatorioCfopService extends CommonService {

  // Ajuste a URL base conforme a configuração da sua API
  private readonly apiUrl = `${environment.urlApiRepoDFe}RelatorioCFOP`;

  constructor(private http: HttpClient) { super(); }

  /**
   * Cria um pedido de busca de DFes recebidos (Relatório CFOP).
   * Endpoint: POST /RelatorioCFOP
   * @param filter Objeto de filtro (GetAllPainelContadorRequest)
   */
  getRelatorioCfop(filter: GetAllPainelContadorRequest): Observable<RelatorioCfopResponse> {
    return this.http.post<RelatorioCfopResponse>(this.apiUrl, filter, this.addHeaderToken());
  }
}